import Vue from 'vue'
import loadingComponent from './loading.vue'

const LoadingConstructor = Vue.extend(loadingComponent)

const instance = new LoadingConstructor({
    el: document.createElement('div')
})

instance.show = true // 默认隐藏

const show = () => {
    instance.show = true
    document.body.appendChild(instance.$el)

}
const hide = () => {
    instance.show = false
}
export default function (Vue) {
    //添加全局API
    Vue.prototype.$loading = {
        show,
        hide
    }
}

export function loadingshow() {
    instance.show = true
    document.body.appendChild(instance.$el)
}
export function loadinghide() {
    instance.show = false
}
